import { Button, ButtonGroup } from "@chakra-ui/react";

export default function Paginator({ onChangePage, page, pages, colorScheme }) {
  const isPrevDisabled = !(page === 1 && pages === 1) && pages !== 0 ? page <= 1 : true;
  const isNextDisabled = !(page === 1 && pages === 1) && pages !== 0 ? page >= pages : true;

  return (
    <ButtonGroup justifyContent={"center"} alignItems={"center"} gap={3}>
      <Button
        colorScheme={colorScheme}
        size={"sm"}
        isDisabled={isPrevDisabled}
        onClick={() => {
          onChangePage((prev) => prev - 1);
        }}
      >
        Previous
      </Button>
      <code>
        {page} / {pages}
      </code>
      <Button
        colorScheme={colorScheme}
        size={"sm"}
        isDisabled={isNextDisabled}
        onClick={() => {
          onChangePage((prev) => prev + 1);
        }}
      >
        Next
      </Button>
    </ButtonGroup>
  );
}
